import { forwardRef, ReactNode, Ref } from 'react';
import { Popover as BasePopover, PopoverProps } from 'reakit';
import { pxToRem } from '@mos-cat/ds-theme';
import { Box } from '../Box/Box';
import { useRequiredPropWarning } from '../hooks/useRequiredPropWarning';

export { PopoverDisclosure, usePopoverState } from 'reakit';

/**
 * @public
 */
type PopoverContentProps = {
  children: ReactNode;
  /**
   * В состоянии `false` убирает отступы. Например, когда содержимое поповера - изображение
   */
  hasPaddings?: boolean;
} & Omit<PopoverProps, 'color' | 'styles'>;

/**
 * @public
 */
export const Popover = forwardRef(
  (
    { children, hasPaddings = true, ...props }: PopoverContentProps,
    ref: Ref<HTMLDivElement>
  ) => {
    useRequiredPropWarning(Boolean(children), 'Popover', 'children');

    return (
      <Box
        as={BasePopover}
        {...props}
        ref={ref}
        zIndex={1011}
        maxWidth={pxToRem(320)}
        className={props.className}
        styles={{
          '&, &:focus, &:focus-visible, &:focus:focus-visible': {
            outline: 0,
          },
        }}
      >
        <Box
          mx="sp-8"
          maxWidth={pxToRem(304)}
          tabIndex={0}
          p={hasPaddings ? 'sp-16' : 'sp-0'}
          bg="white"
          borderRadius="popover"
          border={1}
          borderColor="popoverBorderColor"
          boxShadow="popover"
          overflow="hidden"
          styles={{
            '&, &:focus, &:focus-visible, &:focus:focus-visible': {
              outline: 0,
            },
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }
);
